export default __webpack_public_path__ + "static/media/zeroIndexRates.cf12ed06.svg";